import type {
  BlotterFilterValues,
  ISearchResponse,
  ServerSideBlotterSearchRequest,
} from 'apiConnector/blotters/common';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { TradesBlottersItemByBlotterType } from 'state/blotters/trades/types/blotterItem';
import type { IHttpClient } from 'utils/http/httpClient.model';

export interface IProductsBlotterApi {
  serverSideSearch(
    request: ServerSideBlotterSearchRequest,
  ): Observable<ISearchResponse<TradesBlottersItemByBlotterType<'products'>>>;
  fetchFilterValues(field: string): Observable<BlotterFilterValues>;
}

export function productsBlotterApiConnector(http: IHttpClient): IProductsBlotterApi {
  return {
    serverSideSearch(request: ServerSideBlotterSearchRequest) {
      return http
        .postJSON<ISearchResponse<TradesBlottersItemByBlotterType<'products'>>>({
          url: 'api/v4/blotter/products',
          body: request,
          headers: { Accept: 'application/json' },
        })
        .pipe(map(({ payload }) => payload));
    },
    fetchFilterValues(field: string) {
      return http
        .getJSON<BlotterFilterValues>({
          url: `api/v4/blotter/products/filterValues?field=${field}`,
        })
        .pipe(map(({ payload }) => payload));
    },
  };
}
